import React from 'react'
import Stack from '@mui/material/Stack'

import { useCategoryStore, useScreenSize, WidgetContainer } from '../common'
import { WidgetProps } from '../core'

import TransactionRulesTab from './components/transactionrules/TransactionRulesTab'

export const TransactionRulesWidget = (props: WidgetProps) => {
  const { isMobile } = useScreenSize()
  const { categoriesLoaded, loadCategories } = useCategoryStore()

  React.useEffect(() => {
    if (!categoriesLoaded) {
      loadCategories().finally()
    }
  })

  return (
    <WidgetContainer {...props} showAccountFilter={false}>
      <Stack sx={{ mx: isMobile ? 0 : 48, my: 24 }}>
        <TransactionRulesTab />
      </Stack>
    </WidgetContainer>
  )
}
